import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';

const SrQuoteCard = ({
  headline,
  title,
  text,
  name,
  imageUrl,
}) => {
  return (
    <SrBox
      width='100%'
      backgroundColor='#F4EDE3'
      borderRadius='8px'
      minHeight='280px'
      padding='32px 32px 16px'
      boxSizing='border-box'
      position='relative'
    >
      <SrText
        color='fontBlueDark'
        font='greycliff'
        weight='700'
        size='24'
        lineHeight='32px'
        display='block'
      >
        {headline}
      </SrText>
      <SrBox marginTop='24px' paddingBottom='100px'>
        <SrText
          color='grey500'
          font='greycliff'
          weight='700'
          size='18'
          lineHeight='24px'
          display='block'
          letterSpacing='0px'
        >
          {`"${text}"`}
        </SrText>
      </SrBox>
      <SrFlex position='absolute' bottom='16px' align='center'>
        <SrBox
          backgroundImage={`url(${imageUrl})`}
          backgroundSize='cover'
          backgroundPosition='center'
          backgroundRepeat='noRepeat'
          width='80px'
          height='80px'
          borderRadius='40px'
          marginRight='16px'
        />
        <SrBox>
          <SrText
            color='grey500'
            font='greycliff'
            weight='600'
            size='16'
            lineHeight='24px'
            display='block'
            letterSpacing='0px'
          >
            {name}
          </SrText>
          <SrText
            color='grey500'
            font='greycliff'
            weight='400'
            size='14'
            lineHeight='24px'
            display='block'
            letterSpacing='0px'
          >
            {title}
          </SrText>
        </SrBox>
      </SrFlex>
    </SrBox>
  );
};

SrQuoteCard.propTypes = {
  headline: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

SrQuoteCard.displayName = 'SrQuoteCard';

export default SrQuoteCard;
